import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-waz-ask',
	templateUrl: './waz-ask.component.html',
	styleUrls: ['./waz-ask.component.css']
})
export class WAZaskComponent implements OnInit {

	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any = 10;
	pageNo: any = 1;
	questionList:any = [];
	searchStr:string="";
	constructor(
		private router: Router,
		private pagerService: PagerService, 
		private authService: AuthService,
		private commonService:CommonService
	) {}

	ngOnInit() {
		this.commonService.process();
		//this.commonService.setTitle();
		$(".navbar-brand").text("Topic");
		this.getWorldViewQuestions(this.pageNo, this.limit);
	}

	// Get world view question's list.
	getWorldViewQuestions = function(pageNo, limit,search=''){
		this.commonService.process();

		let request =  {
			page : pageNo,
			num_records : limit,
			search : search,
		};

		this.authService.getWorldViewQuestionsList(request).subscribe(data=>{
			this.commonService.hideProcess();
			if(data.success){
				this.questionList = data.data.question;

				this.questionList.forEach((element,key,obj) => {
					if(element == null){
						delete this.questionList[key];
					}	
				});
				this.total = data.data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
		},error=>{
			this.commonService.hideProcess();
			console.log(error)
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.questionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getWorldViewQuestions(page, this.limit);
		}
	}

	searchUser = function () {
		this.searchStr = jQuery("#search").val();
		this.getWorldViewQuestions(1, this.limit, this.searchStr);
	}

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/waz-ask/waz-ask.component.ts